<script setup lang="ts">
    interface LookbookSlideProps {
        data: LookbookHighlightData;
    }
    const props = defineProps<LookbookSlideProps>();

    const { textColorClass, textColorStyle, buttonColorClass, buttonColorStyle, buttonLabelColorClass, buttonLabelColorStyle } = useStyleCustom(
        props.data.style,
    );
</script>
<template>
    <section
        :id="data.codename"
        class="mol-lookbook-slide relative my-8 lg:my-10 lg:flex lg:min-h-screen-desktop lg:flex-col lg:justify-center">
        <div>
            <atm-grid :id="data.anchor">
                <div class="relative col-span-2 flex flex-col justify-center md:col-span-12 lg:col-span-6">
                    <div class="lb-slide-visual">
                        <atm-image
                            :data="data.hero"
                            preset="3to2" />
                    </div>
                </div>
                <div class="col-span-2 flex md:col-span-12 lg:col-span-5">
                    <div class="flex w-full flex-col max-lg:mx-8 max-md:mx-6 lg:justify-center">
                        <div
                            :class="[textColorClass, 'flex flex-col gap-6']"
                            :style="textColorStyle">
                            <lazy-atm-heading
                                v-if="data.title"
                                level="h3">
                                <renderer-html :content="woomTextFormat(data.title)" />
                            </lazy-atm-heading>

                            <div
                                v-if="data.copy"
                                class="flex flex-col gap-4">
                                <renderer-html :content="woomTextFormat(data.copy)" />
                            </div>
                            <div>
                                <lazy-atm-cta-cms
                                    v-if="data.link?.label"
                                    :link="data.link"
                                    styling="outline-auto"
                                    :class="['mt-2', buttonColorClass, buttonLabelColorClass]"
                                    :style="[buttonColorStyle, buttonLabelColorStyle]">
                                    <renderer-html :content="woomTextFormat(data.link.label)" />
                                </lazy-atm-cta-cms>
                            </div>
                        </div>
                    </div>
                </div>
            </atm-grid>
        </div>
    </section>
</template>
<style scoped>
    @reference "#main.css";
    .lb-slide-visual {
        transform: translateX(var(--translate));
    }
    :deep(h3) {
        @apply text-2xl font-bold;
    }
</style>
